import React from "react";
import Swal from "sweetalert2";
import SelectComponent from "./SelectComponent";
import useLideres from "../hooks/useLideres";
import { buscarParecido, limpiarEspacios } from "../utils/texto";

// Campo "Líder": muestra los líderes ya registrados para elegir uno. Si se
// escribe uno nuevo parecido a uno existente ("Calos" / "Carlos"), pregunta si
// es el mismo antes de crearlo, para no tener el mismo líder escrito distinto.
// valor: nombre del líder ("" o null sin líder). onCambiar recibe el nombre o "".
const SelectLiderComponent = ({ id = "lider", etiqueta = "Líder", claseEtiqueta, valor, onCambiar }) => {
  const { lideres, opcionesLider } = useLideres();

  const crearLider = async (texto) => {
    const nuevo = limpiarEspacios(texto);
    if (!nuevo) return;

    const parecido = buscarParecido(nuevo, lideres);

    // mismo nombre con otras mayúsculas, tildes o espacios: se usa el existente
    if (parecido?.tipo === "igual") {
      onCambiar(parecido.valor);
      return;
    }

    if (parecido?.tipo === "parecido") {
      const { isConfirmed, isDenied } = await Swal.fire({
        icon: "question",
        title: "¿Es el mismo líder?",
        html: `Ya existe el líder <strong>${escaparHtml(parecido.valor)}</strong>.<br/>Escribiste <strong>${escaparHtml(nuevo)}</strong>.`,
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Sí, usar "${parecido.valor}"`,
        denyButtonText: "No, es un líder nuevo",
        cancelButtonText: "Cancelar",
      });
      if (isConfirmed) onCambiar(parecido.valor);
      if (isDenied) onCambiar(nuevo);
      return;
    }

    onCambiar(nuevo);
  };

  return (
    <SelectComponent
      id={id}
      etiqueta={etiqueta}
      claseEtiqueta={claseEtiqueta}
      opciones={opcionesLider}
      valor={valor || null}
      onCambiar={(lider) => onCambiar(lider ?? "")}
      placeholder="Buscar o agregar líder"
      creable
      onCrear={crearLider}
      textoCrear={(texto) => `Agregar nuevo líder: "${limpiarEspacios(texto)}"`}
    />
  );
};

// el nombre lo escribe el usuario: se escapa antes de ir al HTML de la alerta
const escaparHtml = (texto) =>
  texto.replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]);

export default SelectLiderComponent;
